import React, { Component } from 'react';
import { Alert, Button, Input, InputGroup, InputGroupText } from 'reactstrap';
import RepoImpersonation from '../repository/RepoImpersonation';
import authService from './api-authorization/AuthorizeService';
import './ImpersonationBar.css';

export class ImpersonationBar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isAdmin: false,
      isImpersonating: false,
      userId: '',
      targetUser: null,
      originalUserEmail: null,
      error: null,
      loading: false
    };

    this.handleUserIdChange = this.handleUserIdChange.bind(this);
    this.handleStartImpersonation = this.handleStartImpersonation.bind(this);
    this.handleStopImpersonation = this.handleStopImpersonation.bind(this);
  }

  async componentDidMount() {
    await this.checkAdminStatus();
    if (this.state.isAdmin) {
      await this.checkImpersonationStatus();
    }
  }

  async checkAdminStatus() {
    try {
      const user = await authService.getUser();
      const isAdmin = user && user.name === 'jenghan.hsieh@gmail.com';
      this.setState({ isAdmin });
    } catch (err) {
      console.error('Error checking admin status:', err);
    }
  }

  async checkImpersonationStatus() {
    try {
      const status = await RepoImpersonation.getStatus();
      this.setState({
        isImpersonating: status.isImpersonating || false,
        targetUser: status.targetUser || null,
        originalUserEmail: status.originalUserEmail || null
      });
    } catch (err) {
      console.error('Error checking impersonation status:', err);
    }
  }

  handleUserIdChange(e) {
    this.setState({ userId: e.target.value, error: null });
  }

  async handleStartImpersonation() {
    const { userId } = this.state;
    
    if (!userId || isNaN(userId)) {
      this.setState({ error: '請輸入有效的使用者 ID' });
      return;
    }

    this.setState({ loading: true, error: null });

    try {
      const result = await RepoImpersonation.startImpersonation(parseInt(userId));
      
      // 延遲一點再重新載入，確保 session 已經設定
      setTimeout(() => {
        window.location.href = '/';
      }, 500);
    } catch (err) {
      this.setState({
        error: err.response?.data?.message || '模擬失敗，請檢查使用者 ID',
        loading: false
      });
    }
  }

  async handleStopImpersonation() {
    this.setState({ loading: true, error: null });

    try {
      await RepoImpersonation.stopImpersonation();
      
      // 延遲一點再重新載入，確保 session 已經清除
      setTimeout(() => {
        window.location.href = '/';
      }, 500);
    } catch (err) {
      this.setState({
        error: '停止模擬失敗',
        loading: false
      });
    }
  }

  render() {
    const { isAdmin, isImpersonating, userId, targetUser, error, loading } = this.state;

    if (!isAdmin) {
      return null;
    }

    return (
      <div className="impersonation-bar">
        {isImpersonating ? (
          <Alert color="warning" className="mb-0 d-flex align-items-center justify-content-between">
            <span>
              <strong>🎭 模擬模式啟動中</strong> - 正在以使用者 <strong>{targetUser?.realName || targetUser?.email}</strong> (ID: {targetUser?.id}) 的身份操作
            </span>
            <Button 
              color="danger" 
              size="sm" 
              onClick={this.handleStopImpersonation}
              disabled={loading}
            >
              {loading ? '處理中...' : '回到原始身分'}
            </Button>
          </Alert>
        ) : (
          <div className="p-2 bg-light border-bottom">
            <div className="container">
              <InputGroup size="sm">
                <InputGroupText>🔧 系統管理員 - 模擬使用者</InputGroupText>
                <Input
                  type="number"
                  placeholder="輸入使用者 ID"
                  value={userId}
                  onChange={this.handleUserIdChange}
                  disabled={loading}
                  onKeyPress={(e) => {
                    if (e.key === 'Enter') {
                      this.handleStartImpersonation();
                    }
                  }}
                />
                <Button 
                  color="primary" 
                  onClick={this.handleStartImpersonation}
                  disabled={loading || !userId}
                >
                  {loading ? '處理中...' : '開始模擬'}
                </Button>
              </InputGroup>
              {error && (
                <div className="text-danger small mt-1">{error}</div>
              )}
            </div>
          </div>
        )}
      </div>
    );
  }
}
